{
  "Email": "Correo electrónico",
  "Email is Required.": "Su correo electrónico es requerido",
  "Please enter a valid email": "Por favor ingrese un correo electrónico válido",
  "Number of queries must be just a number": "Cantidad de consultas debe ser sólo  número",
  "You must select at least one medical specialty": "Debe seleccionar al menos una especialidad médica",
  "You must enter a value greater than or equal to 1 for the number of queries": "Debe ingresar un valor mayor o igual a 1 para la cantidad de consultas",
  "The number of consultations is required when selecting the medical specialty.": "La cantidad de consultas es requerida al seleccionar la especialidad médica.",
  "Password": "Contraseña",
  "Password is Required.": "Se requiere Contraseña",
  "Password should be minimum of 8 characters.": "La Contraseña debe tener un mínimo de 8 caracteres.",
  "Password should be maximum of 15 characters.": "La Contraseña debe tener un máximo de 15 caracteres.",
  "Please enter valid password.": "Por favor ingrese una contraseña válida.",
  "Remember me": "Recuérdame",
  "Forgot password?": "¿Olvidaste tu contraseña?",
  "Login": "Iniciar Sesión",
  "Forgot Password": "Olvidaste tu contraseña",
  "We will send you link to reset your password": "Le enviaremos un enlace para restablecer su contraseña",
  "Please enter your registered email below": "Ingrese a continuación su correo electrónico registrado",
  "The reset password link has been sent to your registered mail.": "El enlace para restablecer la contraseña ha sido enviado a su correo registrado.",
  "Continue": "Seguir",
  "Set New Password": "Establecer nueva contraseña",
  "Password and confirm password do not match": "Las contraseñas ingresadas no coinciden",
  "Change Password": "Cambia la contraseña",
  "New Password": "Nueva contraseña",
  "Confirm Password": "Confirmar contraseña",
  "Please enter your new password and confirm password.": "Ingrese su nueva contraseña y confirme la contraseña.",
  "Logout": "Cerrar sesión",
  "Add Agent": "Agregar agente",
  "Add New Agent": "Agregar nuevo agente",
  "Edit Agent": "Editar agente",
  "List": "Lista",
  "Admin List": "Lista de administrador",
  "Patient List": "Lista de pacientes",
  "Doctor List": "Lista de doctores",
  "Agent List": "Lista de agentes",
  "Organization List": "Listado de organizaciones",
  "All Consults List": "Lista de todas las consultas",
  "Digital Assets Content" :{
    "Section Name": "Biblioteca de recursos digitales",
    "List Digital Assets": "Lista de recursos digitales",
    "Button Add Digital Assets": "Nuevo Ebook",
    "Button Add Incentive": "Incentivo",
    "Add new Resource": "Agregar nuevo recurso",
    "Update Resource": "Editar recurso",
    "Button Save": "Guardar"
  },
  "Add New Member": "Agregar nuevo miembro",
  "Download Report": "Descargar informe",
  "First Name": "Nombre",
  "Last Name": "Apellido",
  "Gender": "Género",
  "Action": "Estado",
  "Enter Text....": "Ingrese texto",
  "Organization/Insurance Name": "Organización / Aseguradora",
  "Add Doctor": "Agregar doctor",
  "First Name is Required.": "Se requiere su Nombre",
  "Last Name is Required.": "Se requiere su Apellido",
  "Gender is Required.": "Por favor seleccione un género",
  "Add": "Añadir",
  "Edit Doctor": "Editar doctor",
  "Date of Birth": "Fecha de nacimiento",
  "Identification Number": "Cédula de Identidad",
  "Speciality": "Especialidad",
  "Other Speciality": "Otra especialidad",
  "Sub-Speciality": "Subespecialidad",
  "Other Sub-Speciality": "Otra subespecialidad",
  "MPPS Number": "Nro. MPPS",
  "CM Number": "Nro.CM",
  "Phone Number": "Número de teléfono",
  "Status": "Estatus",
  "Recording": "Grabación",
  "Add Organization": "Agregar organización",
  "Organization": "Organización",
  "Organizations": "Organizaciones",
  "Insurance": "Aseguradora",
  "Medical specialties": "Especialidades médicas",
  "Following":"Siguiente",
  "Country Code": "Código de país",
  "Add new organization": "Agregar nueva organización",
  "Add new subsidiary": "Agregar nueva subsidiaria",
  "Subsidiary detail": "Detalle de la subsidiaria",
  "Edit subsidiary": "Editar subsidiaria",
  "Organization Name": "Nombre de la Organización",
  "Organization/Insurance Name is Required.": "Se requiere el nombre de la organización / aseguradora",
  "Organization/Insurance Logo": "Logo de la organización / aseguradora",
  "Organization/Insurance Address": "Dirección de la organización / aseguradora",
  "Identification Number is Required.": "Se requiere su número de cédula de identidad",
  "Country Code is Required": "Se requiere el código del país.",
  "Phone Number is Required.": "Se requiere su número de teléfono",
  "Waiting Room is Required.": "Se requiere la sala de espera",
  "Add New Doctor": "Agregar nuevo doctor",
  "Not verified": "No verificado",
  "Activate": "Activar",
  "Deactivate": "Desactivar",
  "Monthly":"Mensual",
  "Annual":"Anual",
  "Does not apply":"No aplica",
  "Are you sure you want to delete this user?": "¿Estás seguro de que deseas eliminar a este usuario?",
  "Cancel": "Cancelar",
  "Are you sure you want to change the status of this user?": "¿Estás seguro de que deseas cambiar el estatus de este usuario?",
  "Old Password": "Contraseña anterior",
  "Old Password is Required.": "Se requiere la contraseña anterior",
  "Confirm Password is Required.": "Debe confirmar su contraseña",
  "Please enter registered email": "Por favor ingrese el correo electrónico registrado",
  "The old password doesn't match": "La contraseña anterior no coincide",
  "Members": "Afiliados ",
  "Password changed successfully": "Su contraseña ha sido cambiada exitosamente",
  "Active": "Activo",
  "Role": "Rol",
  "Specialist Role": "Rol especialista",
  "Role of Specialist": "Rol de especialista",
  "Last Active Date": "Última fecha activa",
  "Admin Type": "Tipo de administrador",
  "Admin Type Required.": "Tipo de administrador requerido",
  "Add Member": "Añadir miembro",
  "Edit Member": "Editar familiar",
  "Add Admin": "Agregar Administrador",
  "Edit Admin": "Editar Administrador",
  "Edit Patient": "Editar paciente",
  "Edit": "Editar",
  "Membership Type": "Tipo de membresía",
  "Automatic Renewal": "Renovación Automática",
  "Automatic renewal of consultations by specialty":"Renovación automática de consultas por especialidad",
  "Organization details": "Detalles de organización",
  "Venezuelan ID is Required.": "Su número de cédula de identidad es requerido",
  "Organization Name is Required.": "Nombre de Organización/Seguro es requerido",
  "Country Code is Required.": "Se requiere el código del país.",
  "Phone Number is not Valid.": "El número de teléfono posee un formato inválido",
  "Country Code is not valid.": "El código de país es inválido",
  "type": "Tipo",
  "Total number of patients": "Numero total de pacientes",
  "Total number Successful consults": "Número total de consultas exitosas",
  "Total number New consults": "Número total Nuevas consultas",
  "Total number Follow up consults": "Número total de consultas de seguimiento",
  "Type of medical specialty": "Tipo de especialidad médica",
  "Today": "Hoy",
  "This Week": "Esta semana",
  "This Month": "Este mes",
  "This Year": "Este año",
  "Activity Log": "Registro de actividades",
  "Admin": "Administrador",
  "Doctors": "Doctores",
  "Patients": "Pacientes",
  "Insurance providers": "Compañía de seguros o Aseguradoras",
  "Date Of Consult": "Fecha de consulta",
  "Last Activity Date": "Fecha de última actividad",
  "Activity": "Registro",
  "Terms and condions & Privacy Policy": "Términos y Condiciones / Políticas de Privacidad",
  "Terms and condions": "Términos y Condiciones",
  "Privacy Policy": "Políticas de Privacidad",
  "Chief Complaint": "Motivo de consulta",
  "Mode of Communication": "Modo de comunicación",
  "Height": "Altura",
  "Weight": "Peso",
  "BMI": "IMC",
  "Age": "Edad",
  "Back to Home": "Volver al home",
  "Male": "Masculino",
  "Female": "Femenino",
  "Others": "Otro",
  "Visit History": "Historial de consultas",
  "Medical History": "Historia Médica",
  "Medication": "Medicamento",
  "Visit Summary": "Resumen de la consulta",
  "Attachment": "Archivo adjunto",
  "Connect to Patient": "Conectar al paciente",
  "Save & Exit": "Guardar y salir",
  "Save": "Guardar",
  "Consultation completed": "Consulta completada",
  "Follow up call": "Llamada de seguimiento",
  "Date": "Fecha",
  "Return to waiting room": "Devolver a la sala de espera",
  "Video Call": "Videollamada",
  "Phone Call": "Llamada telefónica",
  "Chat": "Chat",
  "Update": "Actualizar",
  "Past Medical History": "Antecedentes personales",
  "Childhood Illnesses": "Enfermedades de la infancia",
  "Other Childillness": "Otras enfermedades de la infancia",
  "Medical Conditions": "Condiciones médicas",
  "Other Medical Condition": "Otras condiciones médicas",
  "Surgery": "Cirugías",
  "Lifestyle information": "Habitos Psicobiologicos",
  "Smoking Habit": "El hábito de fumar",
  "Drinking Habit": "Hábito de beber",
  "Family history": "Antecedentes familiares",
  "Father": "Padre",
  "Other Medical History of Father": "Antecedentes personales  padre",
  "Mother": "Madre",
  "Other Medical History of Mother": "Antecedentes personales  madre",
  "Brother": "Hermano",
  "Other Medical History of Brother": "Antecedentes personales  Hermano",
  "Sister": "Hermana",
  "Other Medical History of Sister": "Antecedentes personales  Hermana",
  "Son": "Hijo",
  "Other Medical History of Son": "Antecedentes personales  Hijo",
  "Daughter": "Hija",
  "Other Medical History of Daughter": "Antecedentes personales  Hija",
  "Select your option": "Selecciones una opción",
  "Currently Taking": "Iniciado",
  "Not Taking": "No Iniciado",
  "Completed": "Tratamiento completado",
  "Delete": "Borrar",
  "Indications": "Indicaciones",
  "Notes": "Notas",
  "Doctor": "Doctor",
  "Choose a Tag": "Elige una etiqueta",
  "View More": "Ver más",
  "Done": "Listo",
  "Follow up": "Seguimiento",
  "Is this Test call?": "¿Es esta llamada de prueba?",
  "Reason for visit": "Razón de consulta",
  "Pregnancy status": "¿Está embarazada?",
  "No": "No",
  "Yes": "Si",
  "Not sure": "No estoy segura",
  "Photos": "Fotos",
  "No Photos Available": "No hay fotos disponibles",
  "History of present illnesses": "Enfermedad actual",
  "Review Of System": "Examen Funcional",
  "Problem": "Problema",
  "Tell What..": "Ingrese texto",
  "Vital signs": "Signos vitales",
  "mmHg": "mmHg",
  "BPSystolic": "Presión arterial sistólica",
  "BPDiastolic": "Presión arterial diastólica",
  "bpm": "lpm",
  "HeartRate": "Frecuencia cardíaca",
  "Respiratory": "Frecuencia Respiratoria",
  "`C": "°C",
  "rbm": "rpm",
  "Temperature": "Temperatura",
  "Medical Information": "Información médica",
  "Paraclinics": "Paraclínicos",
  "Differential Diagnosis": "Diagnóstico diferencial",
  "Diagnosis": "Diagnóstico",
  "Plan": "Plan",
  "Plan is Required.": "Se requiere un plan.",
  "Doctor Notes": "Notas del médico",
  "Paraclinical Prescription": "Examenes de laboratorio",
  "Title": "Título",
  "Description": "Descripción",
  "Medical Prescription": "Prescripción",
  "Dosage": "Dosis",
  "Medication Name": "Medicamento",
  "units": "Unidad",
  "international unit (s)": "unidad (es)",
  "Route (s)": "Ruta de administración (s)",
  "Frequency": "Frecuencia",
  "hours": "Horas",
  "Duration": "Duración",
  "Alternative": "Alternativo",
  "Follow up Information": "Información de seguimiento",
  "Subjective": "Subjetivo",
  "Objective": "Objetivo",
  "Assessment": "Evaluación",
  "In Consult": "En consulta",
  "Queue Status": "Estado de la cola",
  "Average Consultation Length": "Duración promedio de consulta",
  "Average Wait Time": "Tiempo de espera promedio",
  "Time to Completed": "Tiempo para completar",
  "Doctors Online": "Doctores en línea",
  "HolaDoc Doctors": "Médicos HolaDoc",
  "TC & PP": "TC y PP",
  "Documents has been updated successfully": "Documentos actualizados correctamente",
  "The user details has been updated successfully": "Los detalles del usuario se han actualizado correctamente",
  "The user details has been added successfully": "Los detalles del usuario se han agregado correctamente",
  "The user details has been deleted successfully": "Los detalles del usuario se han eliminado correctamente",
  "Password has been changed successfully": "La contraseña ha sido cambiada exitosamente",
  "The user status has been changed successfully": "El estado del usuario se ha cambiado correctamente.",
  "The user has been  download the report successfully": "El usuario ha descargado el informe correctamente",
  "Change": "Cambio",
  "Terms Condition has been added successfully": "Los Términos y Condiciones han sido actualizados satisfactoriamente",
  "Privacy Policy has been added successfully": "La política de privacidad se ha agregado con éxito",
  "visit history  updated Successfully": "historial de visitas actualizado con éxito",
  "Medication status has been changed  to deleted Successfully": "El estado de la medicación se ha cambiado a eliminado.",
  "Medication status has been changed  to completed  Successfully": "El estado del medicamento se ha actualizado correctamente.",
  "Medical History Updated Successfully": "Historial médico actualizado con éxito",
  "Attachment has been Updated Successfully": "El archivo adjunto se ha actualizado correctamente",
  "Medication status  has been changed  to currentlytalking  Successfully": "El estado del medicamento se ha actualizado correctamente.",
  "Medication status has been changed  to currentlynottalking  Successfully": "El estado del medicamento se ha actualizado correctamente.",
  "No records found": "No se encontraron registros",
  "Choose a tags": "Elija una etiqueta",
  "Patients waiting": "Pacientes esperando",
  "Patients completed": "Pacientes completadas",
  "Patients in call": "Pacientes en llamada",
  "Total Patients": "Pacientes totales",
  "alternatives suggested": "alternativas sugeridas",
  "Search": "Buscar",
  "Logs": "Registros",
  "Waiting": "Esperando",
  "Call started": "Llamada iniciada",
  "Call completed": "Llamada completada",
  "Consult completed": "Consulta completada",
  "Canceled": "Cancelada",
  "Primary": "Primaria",
  "FollowUp": "Seguimiento",
  "Today Patients": "Pacientes de hoy",
  "Primary Calls": "Llamadas primarias",
  "Follow up calls": "Seguimiento de llamadas",
  "Venezuelan ID": "Documento de identificación",
  "Identification document": "Documento de identidad",
  "Telephone Nro.": "Nro. Teléfono",
  "Please fill the required fields in visit summary form": "Complete los campos obligatorios en el formulario de resumen de la visita",
  "Please enter description in Paraclinical Prescription": "Introduzca la descripción en Receta paraclínica",
  "Please enter title in Paraclinical Prescription": "Ingrese el título en Receta paraclínica",
  "Medicine name is required": "Se requiere título de medicina",
  "Do you require medical specialties": "Requiere Especialidades médicas",
  "Home": "Inicio",
  "Show": "Mostrar",
  "entries": "entradas",
  "of": "de",
  "record(s)": "registro(s)",
  "Previous": "Anterior",
  "Next": "Siguiente",
  "Copy": "Copy",
  "Excel": "Excel",
  "PDF": "PDF",
  "The user has been copy the table successfully": "El usuario ha copiado la tabla con éxito",
  "Search for organization": "Buscar organización",
  "Type": "Tipo",
  "Business name": "Razón social",
  "RIF": "RIF",
  "Administrators": "Administradores",
  "Total members": "Total miembros",
  "Creation date": "Fecha creación",
  "Actions": "Acciones",
  "Inactive": "Inactivo",
  "Pending": "Pendiente",
  "See detail": "Ver detalle",
  "Add subsidiary": "Agregar subsidiaria",
  "Remove": "Eliminar",
  "Organization data": "Datos de la organización",
  "Organization type": "Tipo de organización",
  "Type of specialty":"Tipo de especialidad",
  "Number of queries":"Cantidad de consultas",
  "Number of consultations per patient for medical specialties":"Cantidad de consultas por paciente para especialidades médicas",  
  "Triage":"Triaje",
  "Requires triage":"Requiere triaje",
  "Business": "Empresa",
  "Bank": "Banco",
  "Tradename": "Nombre Comercial",
  "Tradename is Required.": "Nombre comercial es requerido",
  "Affiliation": "Afiliación",
  "Required field": "Campo requerido",
  "Obligatory field": "Campo obligatorio",
  "The RIF must have 9 digits": " El RIF debe tener 9 dígitos",
  "The RIF can only have digits": "El RIF sólo puede tener dígitos",
  "The business name must have a maximum of 255 characters": "La razón social debe tener un máximo de 255 caracteres",
  "The business name must have a maximum of 50 characters": "La razón social debe tener un máximo de 50 caracteres",
  "Membership name": "Nombre de la afiliación",
  "Parent company": "Empresa matriz",
  "Membership name must have a maximum of 255 characters": "El nombre de la afiliación debe tener un máximo de 255 caracteres",
  "Membership name must have a maximum of 50 characters": "El nombre de la afiliación debe tener un máximo de 50 caracteres",
  "Admin users": "Usuarios administradores",
  "optional": "opcional",
  "Add new user": "Añadir nuevo usuario",
  "User": "Usuario",
  "Name": "Nombre",
  "Name must have a maximum of 255 characters": "El nombre debe tener un máximo de 255 caracteres",
  "Last name": "Apellido",
  "Last name must have a maximum of 255 characters": "El apellido debe tener un máximo de 255 caracteres",
  "Identification number": "Cédula de identidad",
  "Identification number must have a minimum of 8 characters": "La cédula de identidad debe tener un mínimo de 8 caracteres",
  "Identification number must have a maximum of 10 characters": "La cédula de identidad debe tener un máximo de 10 caracteres",
  "Email must have a maximum of 255 characters": "El correo electrónico debe tener un máximo de 255 caracteres",
  "The email must be a valid email": "El correo electrónico debe ser un correo electrónico válido",
  "Delete user": "Eliminar usuario",
  "You must associate at least one user to this organization": "Debe asociar al menos un usuario a esta organización",
  "Are you sure to change the status of the organization?": "¿Estás seguro de cambiar el estatus de la organización?",
  "This action will inactivate admin users and their member users will be disaffiliated from membership": "Esta acción inactivará a los usuarios administradores y sus usuarios miembros serán desafiliados de la membresía",
  "Confirm": "Confirmar",
  "Are you sure you want to delete the organization?": "¿Estás seguro de eliminar esta organización?",
  "It is necessary that the organization has no associated subsidiaries": "Es necesario que la organización no tenga subsidiarias asociadas",
  "Unable to delete an active organization": "No es posible eliminar una organización activa",
  "OK understood": "Ok, entendido",
  "Edit organization": "Editar organización",
  "Organization detail": "Detalle de la organización",
  "The organization is already registered": "La organización ya se encuentra registrada",
  "Report - List of Organizations": "Reporte - Lista de Organizaciones",
  "Email is already in use": "El correo electrónico ya se encuentra en uso",
  "To activate the organization there must be at least one active contact user": "Para activar la organización debe haber al menos un usuario contacto activo",
  "Accept": "Aceptar",
  "Does it require PoweredBy?": "¿Requiere PoweredBy?",
  "Label": "Etiqueta",
  "Label must have a maximum of 255 characters": "Etiqueta debe tener un máximo de 255 caracteres",
  "Customer support": "Atención al cliente",
  "Customer support must have a maximum of 75 characters": "Atención al cliente debe tener un máximo de 75 caracteres",
  "Customer support must be an email": "Atención al cliente debe ser un email",
  "Commercial address": "Dirección comercial",
  "Commercial address must have a maximum of 255 characters": "Dirección comercial debe tener un máximo de 255 caracteres",
  "*.png, *.jpeg, *.jpg. Max size: 5MB": "*.png, *.jpeg, *.jpg. Tamaño max: 5MB",
  "File not allowed": "Archivo no permitido",
  "logo": "logotipo",
  "Waiting room": "Sala de espera",
  "See list": "Ver lista",
  "The following table shows those organizations to which the Physician pays attention": "La siguiente tabla muestra aquellas organizaciones a las que presta atención el Médico",
  "Deleted": "Eliminado",
  "The RIF can only have digits and a hyphen": "El RIF solo puede tener dígitos y un guion",
  "This name is visible to your members": "Este nombre es visible para sus miembros",
  "Do you receive the patients medical report and prescription?": "¿Recibe el informe y la receta médica del paciente?",
  "Users who will receive patient information": "Usuarios que recibirán la información del paciente  ",
  "Add another recipient": "Añadir otro destinatario",
  "The indicated emails are the same": "Los correos indicados son iguales",
  
  "Allies":"Aliados",
  "Add ally":"Agregar aliado",
  "Agreement ID":"Id. convenio",
  "New coupon":"Nuevo cupón",
  "List of allies":"Listado de aliados",
  "Coupon List":"Listado de cupones",
  "Coupon ID":"Id. cupón",
  "Coupons":"Cupones",
  "Total coupons":"Total cupones",
  "Total generated":"Total generado",
  "Total used":"Total usado",
  "Valid until":"Válido hasta",
  "Valid from":"Válido desde",
  "Are you sure you want deactivate the coupon?":"¿Estás seguro que deseas desactivar el cupón?",
  "Are you sure you want deactivate the ally?":"¿Estás seguro que deseas desactivar el aliado?",
  "See ally details":"Ver detalle del aliado",
  "Agreement details":"Datos del convenio",
  "Category":"Categoría",
  "Coupon details" :"Datos del cupón",
  "Successfully added":"Agregado exitosamente",
  "Successfully updated":"Actualizado exitosamente",
  "Add new ally":"Agregar nuevo aliado",
  "Edit ally":"Editar aliado",
  "See coupon detail":"Ver detalle cupón",
  "Discount":"Descuento",
  "Conditions":"Condiciones",
  "Reason":"Motivo",
  "Add new coupon":"Agregar nuevo cupón",
  "Edit coupon":"Editar cupón",
  "Find ally":"Buscar aliado",
  "Find coupon":"Buscar cupones",
  "Logo":"Logotipo",
  "Simple description":"Descripción sencilla",
  "*.png, *.jpeg, *.jpg. Max size: 5MB, 115x60":"*.png, *.jpeg, *.jpg. Max size: 5MB, 115x60",
  "You must enter a maximum of two numbers and %":"Debes ingresar máximo dos números y %",
  "You cannot deactivate an ally with active coupons":"No se puede desactivar un aliado con cupones activos",
  "You must enter a date equal to or greater than the start date":"Debes ingresar una fecha igual o mayor a la de inicio  ",
  "Report - List of coupons":"Informe - Lista de cupones",
  "Report - List of allies":"Informe - Lista de aliados",
  "Are you sure you want to activate the coupon?":"¿Estás seguro que deseas activar el cupón?",
  "Are you sure you want to activate the ally?":"¿Estás seguro que deseas activar el aliado?",
  "You must complete the organization details": "Debe completar los datos de la organización",  
  "Subsidiaries":"Subsidiarias",
  "All": "Todos",
  "Specialty to be treated": "Especialidad a tratar",
  "Specialty to be treated is Required.": "Se requiere especialidad a tratar"
}
